<template>
  <div class="adminMainPage">
    <box :title="$t('downloadFiles')">
      <div class="pa-3 d-flex flex-column">
        <a
          href="https://www.mozilla.org/en-US/firefox/download/thanks/"
          class="my-1"
          >دریافت مرورگر Firefox</a
        >
         <a href="https://www.google.com/chrome/" class="my-1"
          >دریافت مرورگر Chrome</a
        >

        <a href="/files/راهنمای سطح پرسنل وبکارت.pdf" class="my-1"
          >دریافت راهنمای سطح پرسنل وبکارت</a
        >
       
        <a href="/files/راهنمای مدیر سیستم وبکارت.pdf" class="my-1"
          >راهنمای مدیر سیستم وبکارت</a
        >
        <a href="/files/راهنمای نصب وبکارت.pdf" class="my-1"
          >راهنمای نصب وبکارت</a
        >
        <a href="/files/راهنمای وبکارت سطح مدیر.pdf" class="my-1"
          >راهنمای وبکارت سطح مدیر</a
        >
      </div>
    </box>
  </div>
</template>

<script>
export default {
  mounted() {},
};
</script>

<style>
</style>